import script from "./ProfessionSituation.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfessionSituation.vue?vue&type=script&lang=ts&setup=true"

import "./ProfessionSituation.vue?vue&type=style&index=0&id=419a097a&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-419a097a"]])

export default __exports__